import React from "react"
import { Helmet } from "react-helmet-async"
import { Container } from "reactstrap"
import GestionCostes from "components/GestionCostes"

import i18n from "i18n"
import EntitlementPageGuard from "components/Subscription/EntitlementPageGuard"
import { EXPENSES } from "constants/entitlements"

const ExtrasAndContradictionsIndex = () => {
  return (
    <EntitlementPageGuard permission={EXPENSES}>
      <div className="page-content">
        <Helmet>
          <title>Planhopper | {i18n.t("costs.costsGestion")}</title>
        </Helmet>
        <Container fluid>
          <GestionCostes />
        </Container>
      </div>
    </EntitlementPageGuard>
  )
}

export default ExtrasAndContradictionsIndex
